/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style5 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _style6 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style7 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _style8 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _config = require('../../utils/config');

var _tool = require('../../utils/tool');

var _gps = require('../../utils/gps');

var _gps2 = _interopRequireDefault(_gps);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('div', {
    className: 'equipment-fault-tit'
}, void 0, '\u6545\u969C\u4FE1\u606F');

var _ref2 = (0, _jsx3.default)('tr', {
    className: 'equipment-fault-header'
}, void 0, (0, _jsx3.default)('td', {}, void 0, '\u5E8F\u53F7'), (0, _jsx3.default)('td', {}, void 0, '\u6545\u969C'), (0, _jsx3.default)('td', {}, void 0, '\u72B6\u6001'));

var _ref3 = (0, _jsx3.default)('div', {
    className: 'equipment-position-tit'
}, void 0, '\u5F53\u524D\u5145\u7535\u67DC\u4F4D\u7F6E');

var _ref4 = (0, _jsx3.default)('div', {
    className: 'equipment-report-tit'
}, void 0, '\u4E0A\u62A5\u4E8B\u4EF6');

var sbdevice = function (_Component) {
    (0, _inherits3.default)(sbdevice, _Component);

    function sbdevice(props, state) {
        (0, _classCallCheck3.default)(this, sbdevice);

        var _this = (0, _possibleConstructorReturn3.default)(this, (sbdevice.__proto__ || (0, _getPrototypeOf2.default)(sbdevice)).call(this, props, state));

        _this.state = {
            status: '2',
            addressInfo: '',
            allInfo: [],
            deviceDetail: {},
            datas: [],
            batteries: [],
            faultInfo: [],
            reportingTime: '',
            latitude: null,
            longitude: null,
            onlineStatus: null,
            deviceId: '',
            refresh: false,
            lnglat: [],
            batteryCabinetNum: '',
            deviceType: null
        };
        return _this;
    }

    (0, _createClass3.default)(sbdevice, [{
        key: 'refresh',
        value: function refresh() {
            // location.reload()
            this.setState({
                refresh: true
            });
            this.getDeviceInfo();
        }
    }, {
        key: 'goBattery',
        value: function goBattery(res) {
            var deviceType = this.state.deviceType;

            this.props.params.batteryCabinetNum = res.cabinetNum;
            this.props.router.push({
                pathname: '/device/batteryinfo/' + this.props.params.id + '/' + this.props.params.bid + '/' + this.props.params.did + '/' + this.props.params.batteryCabinetNum + '/' + deviceType
            });
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.src = 'https://webapi.amap.com/maps?v=1.4.14&key=4dff992a66514c16d865bff8f1e20396&&callback=amapInitComponent';

            document.head.appendChild(script);

            return new _promise2.default(function (resolve, reject) {
                window['amapInitComponent'] = function () {
                    return resolve();
                };
                script.onerror = function (error) {
                    return reject(error);
                };
            });
        }
    }, {
        key: 'start',
        value: function start() {
            var _this2 = this;

            var _state = this.state,
                longitude = _state.longitude,
                latitude = _state.latitude;

            if (longitude || latitude) {
                var lnglats = _gps2.default.wgs84togcj02(longitude, latitude);
                this.loadMap().then(function () {
                    var config = {
                        resizeEnable: true,
                        zoom: 13,
                        center: lnglats
                    };
                    _this2.map = new AMap.Map("container", config);
                    _this2.map.setDefaultCursor("pointer");
                    //只展示交通路线
                    // map.setFeatures(["road", "point"]);
                    // 加载放大缩小插件
                    // AMap.plugin(['AMap.ToolBar'], ()=>{
                    //     map.addControl(new AMap.ToolBar({
                    //         position: 'RT',
                    //         liteStyle: true,
                    //         offset: (250, 30)
                    //     }));
                    // });
                    var marker = new AMap.Marker({
                        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                        position: lnglats
                    });
                    _this2.map.add(marker);
                });
            } else {}
        }
    }, {
        key: 'address',
        value: function address() {
            var _this3 = this;

            var _state2 = this.state,
                longitude = _state2.longitude,
                latitude = _state2.latitude;

            var lnglats = _gps2.default.wgs84togcj02(longitude, latitude);
            if (longitude || latitude) {
                new _promise2.default(function (resolve, reject) {
                    fetch('https://restapi.amap.com/v3/geocode/regeo?key=4dff992a66514c16d865bff8f1e20396&location=' + lnglats[0] + ',' + lnglats[1]).then(function (res) {
                        if (res.ok) {
                            resolve(res.json());
                        } else {
                            reject();
                        }
                    });
                }).then(function (data) {
                    // console.log(data)
                    _this3.setState({
                        addressInfo: data.regeocode.formatted_address
                    });
                });
            } else {
                this.setState({
                    addressInfo: '未定位'
                });
            }
        }
    }, {
        key: 'getDeviceInfo',
        value: function getDeviceInfo() {
            var _this4 = this;

            var params = this.props.params;

            (0, _tool.http)(_config.apiJson.getDeviceDetailBySerialNumber, { serialNumber: params.bid }).then(function (res) {
                var datas = [];
                var battery = [];
                _this4.setState({
                    deviceType: res.deviceInfo.accessDeviceType
                });
                if (res.deviceCentralizedInfo) {
                    datas = [{
                        statusName: '设备ID',
                        equip: res.deviceInfo.deviceId !== null ? res.deviceInfo.deviceId : '--'
                    }, {
                        statusName: '有功总电度',
                        equip: (res.deviceCentralizedInfo.activeTotalEnergy !== null ? res.deviceCentralizedInfo.activeTotalEnergy / 100 : '--') + 'kWh'
                    }, {
                        statusName: 'ICCID',
                        equip: res.deviceInfo.simIccid !== null ? res.deviceInfo.simIccid : '--'
                    }, {
                        statusName: '当前电表总有功功率',
                        equip: (res.deviceCentralizedInfo.presentTotalActivePower !== null ? res.deviceCentralizedInfo.presentTotalActivePower / 1000 : '--') + 'Kw'
                    }, {
                        statusName: 'SIM卡信号强度',
                        equip: res.deviceCentralizedInfo.simSignalStrength !== null ? res.deviceCentralizedInfo.simSignalStrength : '--'
                    }, {
                        statusName: 'A相电流',
                        equip: (res.deviceCentralizedInfo.presentPhaseACurrent !== null ? res.deviceCentralizedInfo.presentPhaseACurrent / 100 : '--') + 'A'
                    }, {
                        statusName: '电池仓数量',
                        equip: res.deviceCentralizedInfo.totalBatteryCabinet !== null ? res.deviceCentralizedInfo.totalBatteryCabinet : '--'
                    }, {
                        statusName: 'A相电压',
                        equip: (res.deviceCentralizedInfo.presentPhaseAVoltage !== null ? res.deviceCentralizedInfo.presentPhaseAVoltage / 10 : '--') + 'V'
                    }];
                    battery = res.deviceCentralizedInfo.statusInfoList.sort(_this4.compare('cabinetNum'));
                    _this4.setState({
                        faultInfo: res.deviceCentralizedInfo.faultInfoList,
                        longitude: res.deviceCentralizedInfo.longitude,
                        latitude: res.deviceCentralizedInfo.latitude
                    });
                } else {
                    datas = [{ statusName: '设备ID', equip: res.deviceInfo.deviceId !== null ? res.deviceInfo.deviceId : '--' }, { statusName: '有功总电度', equip: '--kWh' }, { statusName: 'ICCID', equip: res.deviceInfo.simIccid !== null ? res.deviceInfo.simIccid : '--' }, { statusName: '当前电表总有功功率', equip: '--Kw' }, { statusName: 'SIM卡信号强度', equip: '--' }, { statusName: 'A相电流', equip: '--A' }, { statusName: '电池仓数量', equip: '--' }, { statusName: 'A相电压', equip: '--V' }];
                    if (res.deviceInfo.accessDeviceType === 331) {
                        for (var i = 0; i < 3; i++) {
                            battery.push({ batteryStatus: null, bookingStatus: null, cabinetNum: '--', chargerStatus: null, lockStatus: null });
                        }
                    } else if (res.deviceInfo.accessDeviceType === 330) {
                        for (var _i = 0; _i < 8; _i++) {
                            battery.push({ batteryStatus: null, bookingStatus: null, cabinetNum: '--', chargerStatus: null, lockStatus: null });
                        }
                    }
                }
                _this4.setState({
                    deviceDetail: res,
                    datas: datas,
                    batteries: battery,
                    reportingTime: res.deviceInfo.lastHeartbeatTime,
                    onlineStatus: res.deviceInfo.onlineStatus,
                    deviceId: res.deviceInfo.deviceId
                });
                _this4.start();
                _this4.address();
                setTimeout(function () {
                    _this4.setState({
                        refresh: false
                    });
                }, 400);
            });
        }
    }, {
        key: 'getDeviceEventList',
        value: function getDeviceEventList() {
            var params = this.props.params;

            (0, _tool.http)(_config.apiJson.getDeviceEventList, { deviceId: params.did }).then(function (res) {
                console.log(res);
            });
        }
    }, {
        key: 'compare',
        value: function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            };
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDeviceInfo();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getDeviceEventList();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {}
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var params = this.props.params;
            var _state3 = this.state,
                deviceDetail = _state3.deviceDetail,
                datas = _state3.datas,
                batteries = _state3.batteries,
                faultInfo = _state3.faultInfo,
                reportingTime = _state3.reportingTime,
                onlineStatus = _state3.onlineStatus,
                addressInfo = _state3.addressInfo;
            // console.log(onlineStatus)

            var columns = [{
                title: '序号',
                dataIndex: 'key',
                key: 'key'
            }, {
                title: '电池仓',
                dataIndex: 'name',
                key: 'name'
            }, {
                title: '事件',
                dataIndex: 'eventMessage',
                //   key: 'address',
                render: function render(eventMessage) {
                    return (0, _jsx3.default)('p', {}, void 0, eventMessage);
                }
            }, {
                title: '时间',
                dataIndex: 'createTime',
                key: 'createTime'
            }];

            var paginations = {
                defaultPageSize: 1
                //   console.log('1',this.state.addressInfo)
            };var pagination = {
                pageSize: 5,
                // showSizeChanger: true,
                showQuickJumper: true,
                Totel: 0,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: function showTotal(total) {
                    return '\u5171 ' + total + ' \u6761';
                }
            };
            return (0, _jsx3.default)('div', {
                className: 'equipment'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'equipment-header'
            }, void 0, (0, _jsx3.default)('h3', {}, void 0, '\u8BBE\u5907\u7F16\u53F7\uFF1A', (0, _jsx3.default)('span', {}, void 0, params.bid)), (0, _jsx3.default)('div', {
                className: 'equipment-sta'
            }, void 0, (0, _jsx3.default)('span', {
                className: 'state1',
                style: { background: onlineStatus === 1 ? '#80C269' : '#ddd' }
            }), (0, _jsx3.default)('span', {
                className: 'state2'
            }, void 0, _tool.filter.lineStatus(onlineStatus))), (0, _jsx3.default)('div', {
                className: 'equipment-refresh'
            }, void 0, (0, _jsx3.default)(_icon2.default, {
                type: 'sync',
                spin: this.state.refresh,
                onClick: this.refresh.bind(this)
            }))), (0, _jsx3.default)('div', {
                className: 'equipment-info'
            }, void 0, (0, _jsx3.default)(_row2.default, {
                className: 'equipment-info-left'
            }, void 0, datas.map(function (res, i) {
                return (0, _jsx3.default)(_col2.default, {
                    className: 'ele-2'
                }, i, res.statusName, '\uFF1A', res.equip);
            })), (0, _jsx3.default)('div', {
                className: 'equipment-info-right'
            }, void 0, (0, _jsx3.default)('ul', {
                className: 'equipment-info-list'
            }, void 0, batteries.map(function (res, i) {
                return (0, _jsx3.default)('li', {
                    onClick: _this5.goBattery.bind(_this5, res)
                }, i, (0, _jsx3.default)('h3', {}, void 0, '\u7535\u6C60\u4ED3\uFF1A', res.cabinetNum), (0, _jsx3.default)('div', {}, void 0, '\u9501\u72B6\u6001\uFF1A', _tool.filter.lockStatus(res.lockStatus)), (0, _jsx3.default)('div', {}, void 0, '\u7535\u6C60\u72B6\u6001\uFF1A', _tool.filter.batteryStatus(res.batteryStatus)), (0, _jsx3.default)('div', {}, void 0, '\u7535\u6C60\u4ED3\u72B6\u6001\uFF1A', _tool.filter.chargerStatus(res.chargerStatus)), _this5.state.deviceType == 332 || _this5.state.deviceType == 335 ? (0, _jsx3.default)('div', {}, void 0, '\u7535\u6C60\u7248\u672C\u53F7\uFF1A', res.batteryVersion2 && res.batteryVersion1 ? 'v' + res.batteryVersion2 + (res.batteryVersion1 > 10 ? '.' : '.0.') + res.batteryVersion1 : '--') : '');
            })))), (0, _jsx3.default)('div', {
                className: 'equipment-fault'
            }, void 0, _ref, (0, _jsx3.default)('table', {
                className: 'equipment-fault-info',
                style: { width: "30%" }
            }, void 0, _ref2, faultInfo.map(function (item, index) {
                return (0, _jsx3.default)('tr', {
                    className: 'equipment-fault-footer'
                }, index, (0, _jsx3.default)('td', {}, void 0, index + 1, '.'), (0, _jsx3.default)('td', {}, void 0, _tool.filter.faultInfo(item.function)), (0, _jsx3.default)('td', {}, void 0, _tool.filter.faultInfoStatus(item.status)));
            }))), (0, _jsx3.default)('div', {
                className: 'equipment-position'
            }, void 0, _ref3, (0, _jsx3.default)('div', {
                className: 'equipment-position-info',
                id: 'map'
            }, void 0, (0, _jsx3.default)('div', {
                id: 'container',
                style: { width: '100%', height: '100%' }
            })), (0, _jsx3.default)('div', {
                className: 'equipment-position-posi'
            }, void 0, (0, _jsx3.default)('p', {}, void 0, addressInfo), (0, _jsx3.default)('p', {}, void 0, '\u6700\u65B0\u4E0A\u62A5\u65F6\u95F4\uFF1A', reportingTime))), (0, _jsx3.default)('div', {
                className: 'equipment-report'
            }, void 0, _ref4, (0, _jsx3.default)('div', {
                className: 'equipment-report-list'
            }, void 0, (0, _jsx3.default)(_table2.default, {
                columns: columns,
                style: { width: "60%" },
                pagination: pagination
            }))));
        }
    }]);
    return sbdevice;
}(_react.Component);

exports.default = sbdevice;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/index.jsx
// module id = 1547
// module chunks = 0